export enum AnalyticOutputTypeEnum {
  WORK_MIRROR = 'work_mirror',
  AUTHOR_MIRROR = 'author_mirror',
  READERSHIP_PROFILE_PREVIEW = 'readership_profile_preview',
  READERSHIP_PROFILE_TITLE = 'readership_profile_title',
  READERSHIP_PROFILE_DATASET = 'readership_profile_dataset',
  READERSHIP_PROFILE_IMAGE = 'readership_profile_image',
  READERSHIP_PROFILE_TEXTBOX = 'readership_profile_textbox',
  READERSHIP_PROFILE_STUDY_OBJECT = 'readership_profile_study_object',
}
